import {define} from './define'
import type {GroupReturn} from '../types'

export const options = (): GroupReturn => define('options')
